import script from "./FilterHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterHistory.vue?vue&type=script&setup=true&lang=ts"

import "./FilterHistory.vue?vue&type=style&index=0&id=4b732ad8&lang=css"

const __exports__ = script;

export default __exports__